import { render, staticRenderFns } from "./WayDetail.vue?vue&type=template&id=b5c33918&scoped=true"
import script from "./WayDetail.vue?vue&type=script&lang=js"
export * from "./WayDetail.vue?vue&type=script&lang=js"
import style0 from "./WayDetail.vue?vue&type=style&index=0&id=b5c33918&prod&lang=scss&scoped=true"
import style1 from "./WayDetail.vue?vue&type=style&index=1&id=b5c33918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c33918",
  null
  
)

export default component.exports